import axios from 'axios'
import { CallsUrlBase, UrlBase } from '@/services/config'

const calls = {}

calls.callPerson = async (token, companyId, appId, data) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data,
      url: `${CallsUrlBase}${companyId}/${appId}/calls/click/to/call`
    }
    await axios(request)
  } catch (e) {
    console.error(e)
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}
calls.getAdministratorCallConfig = async (token, companyId, administratorId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${UrlBase}administrator/companies/${companyId}/userId/${administratorId}/click/to/call/config`
    }
    const response = await axios(request)
    return response.data.result
  } catch (e) {
    console.error(e)
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

calls.getAppCalls = async (token, companyId, appId, data) => {
  try {
    const params = {}
    for (const key in data) {
      if (data[key]) {
        params[key] = data[key]
      }
    }
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params,
      url: `${CallsUrlBase}${companyId}/${appId}/calls`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.error(e)
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

calls.updateAdministratorCallConfig = async (token, companyId, administratorId, data) => {
  try {
    const { clientId, password, userEmail } = data
    const callConfig = {
      clientId,
      userEmail
    }
    if (password) {
      callConfig.password = password
    }
    const request = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        provider: 'net2phone',
        ...callConfig
      },
      url: `${UrlBase}administrator/companies/${companyId}/userId/${administratorId}/click/to/call/config`
    }
    await axios(request)
  } catch (e) {
    console.error(e)
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

export default calls
